import Tooltip from '@material-ui/core/Tooltip';
import { t } from 'ttag';
import React from 'react';

export const CyrillicTooltiop = ({ open, children }) => {
  if (open) {
    return (
      <Tooltip placement='top' title={t`Дозволино тільки кириличні символи `}>
        <span>{children}</span>
      </Tooltip>
    );
  }
  return children;
};
